import React, { useState, useContext } from 'react';
import 'twin.macro';
import { useNavigate } from 'react-router-dom';
import { Button } from '../button';
import { Input } from './FormParticals';
import { AppContext } from '../context';
import { MenuNavLink } from '../linktypes';
import { Small } from '../text';
import { formatDate } from '../../lib/helpers';
import { CalendarIcon } from 'icons';

const DateForm = ({ children, ...props }) => (
  <form tw='flex items-end gap-4' {...props}>
    {children}
  </form>
);

export const GoToDateSelectForm = ({ children, ...props }) => (
  <DateForm {...props}>{children}</DateForm>
);

export const DaysBackForm = ({ children, ...props }) => <DateForm {...props}>{children}</DateForm>;

export const GoToDateSelectButton = ({ ...props }) => <Button type='submit' primary {...props} />;

export const DaysBackButton = ({ ...props }) => <Button type='submit' primary {...props} />;

export const GoToDateForm = () => {
  const navigate = useNavigate();
  const { setSlideIn } = useContext(AppContext);

  const [goToDate, setGoToDate] = useState('');
  const [daysBack, setDaysBack] = useState(1);
  const today = new Date();

  const submit = (e, isGoToDate) => {
    e.preventDefault();
    setSlideIn({ fullwidth: false, active: false, Component: () => <></> });
    navigate(
      isGoToDate ? `/datum/${goToDate.split('-').reverse().join('-')}` : `/nieuw/dag/${daysBack}`,
    );
  };

  return (
    <>
      <GoToDateSelectForm onSubmit={(e) => submit(e, true)} tw='mb-4'>
        <div tw='relative'>
          <Input
            placeholder='Ga naar datum'
            min='2006-03-20'
            max={formatDate(today, true, true).split('-').reverse().join('-')}
            type='date'
            name='gotodate'
            id='gotodate'
            value={goToDate}
            onChange={(e) => setGoToDate(e.target.value)}
            label={goToDate ? 'Ga naar datum' : ''}
            tw='mb-0 w-40'
          />
          <div tw='hidden lg:flex bg-input-back justify-center items-center absolute h-7 w-7 bottom-1 right-1 cursor-pointer pointer-events-none'>
            <CalendarIcon />
          </div>
        </div>
        <GoToDateSelectButton
          label={`Ga naar ${goToDate === '' ? 'datum' : formatDate(goToDate).split('-').reverse().join('-')}`}
          disabled={goToDate === ''}
        />
      </GoToDateSelectForm>
      <DaysBackForm onSubmit={submit}>
        <Input
          type='range'
          min='1'
          max='365'
          placeholder='Aantal dagen terug'
          name='daysback'
          id='daysback'
          value={daysBack}
          onChange={(e) => setDaysBack(e.target.value)}
          label={daysBack ? 'Aantal dagen terug' : ''}
          tw='mb-0 px-0 rounded-none text-dark border-0 cursor-grab w-40'
          style={{ accentColor: '#66cc22' }}
        />
        <DaysBackButton
          label={`${daysBack} Dag${Number(daysBack) > 1 ? 'en' : ''} terug`}
          disabled={daysBack === ''}
        />
      </DaysBackForm>
      <Small
        text='Je kan maximaal 365 dagen terug. Wil je verder terug zoeken, gebruik dan een datum.'
        tw='block mt-3 ml-2'
      />
      <hr tw='border-icons opacity-20 mt-6 mb-3' />
      <div tw='flex flex-col'>
        <MenuNavLink
          label='Gisteren'
          to='/nieuw/dag/1'
          onClick={() => {
            setSlideIn({
              fullwidth: false,
              active: false,
              Component: () => <></>,
            });
          }}
        />
        <MenuNavLink
          label='Vorige Week'
          to='/nieuw/week/1'
          onClick={() => {
            setSlideIn({
              fullwidth: false,
              active: false,
              Component: () => <></>,
            });
          }}
        />
      </div>
    </>
  );
};
